import { useEffect, useState } from 'react';
import db from '@/db';
import { AlertTriangle } from 'lucide-react';

export default function TrainingBanner() {
  const [active, setActive] = useState(false);

  const refresh = async () => {
    const c = await db.config.get('trainingMode');
    setActive(!!c?.value);
  };

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 3000);
    const handler = () => refresh();
    window.addEventListener('kaven:training-toggle', handler);
    return () => {
      clearInterval(interval);
      window.removeEventListener('kaven:training-toggle', handler);
    };
  }, []);

  if (!active) return null;

  return (
    <div
      data-testid="training-banner"
      className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-white text-center py-2 px-4 shadow-lg"
      style={{
        backgroundSize: '200% 100%',
        animation: 'trainingPulse 3s ease-in-out infinite',
      }}
    >
      <style>{`
        @keyframes trainingPulse {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `}</style>
      <div className="flex items-center justify-center gap-2 font-bold text-sm tracking-wide uppercase">
        <AlertTriangle size={16} strokeWidth={2} />
        <span>Modo Treinamento Ativo — dados não contam no financeiro real</span>
        <AlertTriangle size={16} strokeWidth={2} />
      </div>
    </div>
  );
}
